import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { RegionComunaDTO } from 'app/main/apps/shared/interfaces/region-comuna.interface';


@Component({
  selector: 'app-search-regiones',
  templateUrl: './search-regiones.component.html',
  styleUrls: ['./search-regiones.component.scss']
})
export class SearchRegionesComponent implements OnInit {
  @Input() regiones: RegionComunaDTO[];
  @Output() regionEvent: EventEmitter<number> = new EventEmitter();
  
  constructor() { }

  ngOnInit(): void {
    //console.log(this.regiones);
  }

  buscarComunas(event: MatSelectChange){
    //console.log(event);
    this.regionEvent.emit(event.value);
  }

}
